export const freightPrices = {
    car: {
        'HARRIER': 3000,
        'PRIUS': 2500,
        'LEAF': 2500,
        'NOTE': 2500,
        'AQUA': 2500,
        'X-TRAIL': 2500,
        'RAV-4': 2500,
        'VEZEL': 2500,
        'FORESTER': 2500,
        'CX-5': 2500,
        'CROWN': 2500,
        'ISIS': 2500,
        'WISH': 2500,
        'FIELDER': 2500,
        'CH-R': 2500,
        'NV200': 2500,
        'CRV': 2500,
        'CX-8': 3000,
        'OUTLANDER': 2500,
        'MX-30': 2500,
        'ALPHARD': 3000,
        'VELLFIRE': 3000,
        'SERENA': 3000,
        'VOXY': 3000,
        'STEPWAGON': 3000,
        'DELICA': 3000,
        'HIACE': 3000,
        'CARAVAN': 3000,
        'ESTIMA': 3000,
        'ODYSSEY': 3000,
        'PRADO': 3000,
        'LAND CRUISER': 3500,
        'HILUX SURF': 3000,
        'FJ CRUISER': 3000,
        'LEXUS RX': 3000,
        'BMW X5': 3000,
        'BMW X6': 3000,
        'SAFARI': 3500
    } as Record<string, number>,
    truck: [
        {length: 0, price: 4000},
        {length: 500, price: 5000},
        {length: 600, price: 6000},
        {length: 700, price: 7000},
        {length: 800, price: 8000},
        {length: 900, price: 9000},
        {length: 1000, price: 9000},
        {length: 1200, price: 10000},
    ],
    specialEquipment: [
        {weight: 0, price: 2500},
        {weight: 2500, price: 2750},
        {weight: 3000, price: 3000},
        {weight: 3500, price: 3500},
        {weight: 4000, price: 4000},
        {weight: 4500, price: 4250},
        {weight: 5000, price: 4500},
        {weight: 5500, price: 4750},
        {weight: 6000, price: 5000},
        {weight: 6500, price: 5250},
        {weight: 7000, price: 5500},
        {weight: 7500, price: 5750},
        {weight: 8000, price: 6000},
        {weight: 8500, price: 6250},
        {weight: 9000, price: 6500},
        {weight: 9500, price: 6750},
        {weight: 10000, price: 7000},
    ],
}

export const disPrices = {
    car: 550,
    truck: [
        {length: 400, price: 600},
        {length: 500, price: 600},
        {length: 600, price: 700},
        {length: 700, price: 750},
        {length: 800, price: 800},
        {length: 900, price: 950},
        {length: 1000, price: 1000},
        {length: 1200, price: 1000},
    ],
    specialEquipment: 1000,
}
